import { IToolPanelAngularComp } from '@ag-grid-community/angular'
import { IToolPanelParams } from '@ag-grid-community/core'
import { Component } from '@angular/core'
import { FormControl } from '@angular/forms'
import { PanelSettingsToolPanelParams } from './utils/panel-settings-tool-panel-sidebar-utils'

export type AgInitParams = PanelSettingsToolPanelParams & IToolPanelParams
export interface AdvanceControlPanel {
  label: string
  control: FormControl
}

@Component({
  selector: 'hs-panel-settings-tool-panel',
  templateUrl: './panel-settings-tool-panel.component.html',
  styleUrls: ['./panel-settings-tool-panel.component.scss'],
})
export class PanelSettingsToolPanelComponent implements IToolPanelAngularComp {
  agInitParams?: AgInitParams

  initComplete = false
  advanceControlMap: AdvanceControlPanel[] = []

  async agInit(params: AgInitParams): Promise<void> {
    this.agInitParams = params
    this.agInitParams.controls.forEach(control => {
      this.advanceControlMap.push({
        label: control.label,
        control: control.formControl,
      })
    })
    this.initComplete = true
  }
}
